export default __webpack_public_path__ + "static/media/kokoro-4.e517462c.png";